import { useState } from "react"
import axios from "axios"
import { baseURL } from "constants/api"

// Распознаёт фото меню ресторана на отдельные блюда.
// Вызывает бэкенд-эндпоинт POST /menu/parse — ключ Anthropic хранится на сервере
// и не попадает в браузер.

// Поддерживаемые vision-форматы Claude
const SUPPORTED_MEDIA_TYPES = ["image/jpeg", "image/png", "image/gif", "image/webp"]

// Читает File в base64 (без data:-префикса) и возвращает { data, mediaType }
const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      const result = reader.result // data:image/...;base64,XXXX
      const base64 = String(result).split(",")[1]
      resolve({ data: base64, mediaType: file.type })
    }
    reader.onerror = () => reject(new Error("Не удалось прочитать файл изображения"))
    reader.readAsDataURL(file)
  })

const useMenuParser = () => {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState("")

  const parseMenu = async (file) => {
    if (!file) {
      setError("Файл не выбран")
      return null
    }

    if (!SUPPORTED_MEDIA_TYPES.includes(file.type)) {
      setError("Поддерживаются только изображения JPEG, PNG, GIF или WEBP")
      return null
    }

    setLoading(true)
    setError("")

    try {
      const { data: base64, mediaType } = await fileToBase64(file)

      const response = await axios.post(`${baseURL}/menu/parse`, {
        image: base64,
        mediaType,
      })

      const dishes = Array.isArray(response.data?.dishes) ? response.data.dishes : []

      if (dishes.length === 0) {
        setError("На изображении не найдено блюд. Попробуйте более чёткое фото меню.")
        return []
      }

      return dishes
    } catch (err) {
      const errorMessage =
        err.response?.data?.message || err.message || "Произошла ошибка при распознавании меню"
      setError(errorMessage)
      console.error("Menu parsing error:", err)
      return null
    } finally {
      setLoading(false)
    }
  }

  return {
    loading,
    error,
    parseMenu,
  }
}

export default useMenuParser
